import { Icon } from '../ui/Icon';
import s from './CsvDownloads.module.css';

/**
 * The four CSV files `GET /exports/:file` serves: whole tables, not a screen's view of them. One
 * definition for every place that offers them (Office → Stock's Download CSV menu, and Settings →
 * Google Sheets). They are plain links, not fetches, so the browser streams each file to disk with
 * the session cookie; the API checks `export`, and the pages show them only to those who hold it.
 */
export const CSV_DOWNLOADS = [
  { file: 'live-stock.csv', label: 'Live stock', line: 'In stock, reserved and available for every SKU at every site, with totals.' },
  { file: 'skus.csv', label: 'SKUs', line: 'Every SKU and its attributes.' },
  { file: 'boxes.csv', label: 'Boxes', line: 'Every box: its SKU, status, site, pallet, and order or transfer.' },
  { file: 'orders.csv', label: 'Orders (last 90 days)', line: 'One row per order line, for orders created in the last 90 days.' },
] as const;

/** The four downloads as a list: a card's rows, or `compact`, a menu's, with each line under its link. */
export function CsvDownloads({ compact = false, onPick }: { compact?: boolean; onPick?: () => void }) {
  return (
    <ul className={`${s.files} ${compact ? s.compact : ''}`} aria-label="CSV downloads">
      {CSV_DOWNLOADS.map((d) => (
        <li key={d.file}>
          <a className={s.file} href={`/api/v1/exports/${d.file}`} download onClick={onPick}>
            <Icon name="download" />
            {d.label}
          </a>
          <span>{d.line}</span>
        </li>
      ))}
    </ul>
  );
}
